module.exports = __webpack_public_path__ + "img/grp-part-8-option-4.f72a907c.png";